
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"20.989"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#3a3a3a"}},[_c('path',{attrs:{"data-name":"Path 366","d":"M25 5.274a2.321 2.321 0 01-.658 1.192 1.971 1.971 0 01-.921.469.241.241 0 00-.23.23q-.913 4.8-1.842 9.6c-.033.173-.082.238-.271.238q-8.586-.012-17.163-.008c-.066 0-.132-.008-.214-.008a131.1 131.1 0 01-.329-1.727q-.789-4.058-1.563-8.117c-.025-.14-.09-.181-.222-.214A1.975 1.975 0 010 5.003a2.031 2.031 0 011.587-1.965 2 2 0 012.229 1.143 1.946 1.946 0 01-.633 2.393c-.181.132-.164.214-.09.387a9.243 9.243 0 001.924 2.887 4.192 4.192 0 001.365.929 2.692 2.692 0 002.961-.576 5.921 5.921 0 001.234-1.62 14.414 14.414 0 001.3-3.668 2.537 2.537 0 01-1.729-1.583 2.386 2.386 0 01-.033-1.6 2.5 2.5 0 014.811.2 2.428 2.428 0 01-.3 1.85c-.3.5-.444.592-1.521 1.16.173.592.321 1.2.518 1.793a8.557 8.557 0 001.719 3.166 2.816 2.816 0 003.939.518 8.21 8.21 0 002.706-3.668c-.189-.173-.37-.321-.526-.493a1.94 1.94 0 01-.247-2.146 1.992 1.992 0 013.742.51.413.413 0 00.041.107z"}}),_c('path',{attrs:{"data-name":"Path 367","d":"M12.525 17.996h7.812a1.529 1.529 0 011.456.757 1.487 1.487 0 01-1.135 2.229c-.1.008-.2.008-.3.008H4.638a1.5 1.5 0 01-.263-2.985c.132-.008.263-.016.387-.016 2.59.007 5.169.007 7.763.007z"}})])])
          )
        }
      }
    